/* Keeps the refill "Add" button in sync with its size/pack dropdown */
document.addEventListener('change', function (e) {
  var sel = e.target.closest && e.target.closest('[data-refill-select]');
  if (!sel) return;
  var wrap = sel.closest('.refill-actions');
  var btn = wrap && wrap.querySelector('[data-quick-add]');
  if (btn) btn.setAttribute('data-variant-id', sel.value);
});

/* Mini cart: a manual "hide for now" on the always-on preview panel. It reappears automatically
   the next time the cart changes (theme.js clears .is-dismissed inside refreshCart). */
document.addEventListener('click', function (e) {
  var dismiss = e.target.closest && e.target.closest('[data-mini-cart-dismiss]');
  if (!dismiss) return;
  var root = dismiss.closest('[data-mini-cart]');
  if (root) root.classList.add('is-dismissed');
});
